<template>
    <v-menu bottom left>
        <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-printer</v-icon>
            </v-btn>
        </template>
        <v-list class="py-0">
            <v-list-item v-for="(item, i) in items" :key="i" @click="action(item.route)">
                <v-list-item-icon class="mr-2"><v-icon>mdi-file-document-outline</v-icon></v-list-item-icon>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
    export default {
        name: "spiel-berichte-print-menu",
        props: ['spielId', 'type'],
        computed: {
            items(){
                if ( this.type === 'pending' ) {
                    return [{ title: 'MaL', route: 'PrintMaL' },
                            { title: 'SR-Blatt', route: 'PrintSrBlatt' },
                            { title: 'Wurfzettel', route: 'PrintWurfzettel' },
                            { title: 'Spielbericht', route: 'PrintSpielbericht' },
                            { title: 'Spielbericht leer', route: 'PrintSpielberichtLeer' }];
                } else {
                    return [ { title: 'Spielbericht', route: 'PrintSpielbericht' }];
                }
            }
        },
        methods: {
            action(routeName){
                let routeData = this.$router.resolve({name: routeName, query: {id: this.spielId}});
                window.open(routeData.href, '_blank');
            }
        },
    }
</script>

<style scoped>

</style>